import { withCurrentParams } from 'actions/utils';
import { SCENE_CREATE } from 'store/eventConstants';
import { BROADCAST_SCENE_DUPLICATE } from 'actions/Types';

/**
 * Duplicate scene action
 *
 * @param {Object} sceneId
 * @param {boolean} shouldUpdateProgram
 */
export default sceneId => {
  return withCurrentParams(
    (dispatch, { teamId, eventId, broadcastId }, getState, socket) => {
      const action = {
        type: BROADCAST_SCENE_DUPLICATE,
        request: async apiClient => {
          const response = await apiClient.broadcast.duplicateScene(
            teamId,
            eventId,
            broadcastId,
            sceneId
          );

          const {
            meeting: { attendeeResponse }
          } = getState();

          socket.emit(SCENE_CREATE, {
            broadcastId,
            notifyingDirector:
              attendeeResponse && attendeeResponse.Attendee.AttendeeId
          });

          return { scenes: response.scenes };
        }
      };
      dispatch(action);
    }
  );
};
